<template>
  <div class="PageNotFound">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-md-offset-4">
          <h1>{{msg}}</h1>
          <h5>There's nothing here.</h5>
          <router-link to="/" class="page-not-found-link">Take me home.</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  data () {
    return {
      msg: 'Page Not Found'
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1{
  color: #2c3e50;
  font-size: 30px;
  font-weight: bold;
}
h5{
  padding-left: 25px;
  border-left: #ccc 5px solid;
  font-weight: normal;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.page-not-found-link
{
  color: #3eaf7c;
  font-size: 20px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/PageNotFound.vue